import styles from './index.module.sass'

const Divider = () => (
  <div className={styles.dividerWrapper}>
    <div className={styles.divider} />
  </div>
)

export default Divider
